import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import socket from './modules/socket';
import ide from './modules/ide';
import exam from './modules/exam';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    socket,
    ide,
    exam,
  },
  getters,
});
